
import { useEffect, useState } from '../../common/common';
import useGetUserData from '../../secureAPI/GetUserData';
import Navigations from '../../common/useNavigation.js';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils.js';
import axiosJWT from '../../secureAPI/axiosJWT.js';
import { showToast } from '../../Utils/toastUtils.js';

const MidViewSuppliers = (type) => {
  const { users } = useGetUserData();
  const { navigateDashboard, navigateViewSuppliers } = Navigations();

  const [isLoading, setisLoading] = useState(false);
  const [products, setProducts] = useState([]);

  useEffect(() => {
          const logUserData = () => {
              if (users?.length > 0 && type !== '') {
                  const userTypes = users[0]['UserType'];
                  const usertypeArray = typeof userTypes === 'string' ?
                      userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
  
                  const hasOne = usertypeArray.includes(1);
                  const hasTwo = usertypeArray.includes(2);
                  if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && (hasOne || (hasOne && hasTwo))) { }
                  else {
                      navigateDashboard('buyer');
                  }
              }
          };
  
          if (Array.isArray(users) && users.length > 0) {
              logUserData();
          }
      }, [users, type]);




  // useEffect(() => {
  //   //  console.log('called useeffectsss');
  //     if (Array.isArray(users) && users.length > 0) {
  //         console.log('useEffect called, users:', users);
  //         logUserData(); 
  //     }
  // }, [users]); 
  
  //   const logUserData = () => {
  //     if (users?.length > 0) {
  //       if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && (parseInt(users[0]['UserType']) === 1 || users[0]['UserType'] === '1,2') ) {
            
  //         }
  //         else
  //         {
  //           navigateDashboard('buyer');
  //         }
  //     }
  //   };
  const selectsupplier = (row_id) => {
    const supplier_id = row_id;
    navigateViewSuppliers(supplier_id,type);
  }
  const handleCall = (phoneNumber) => {
    // console.log(`Calling ${phoneNumber}`);
  };
  useEffect(() => {
    getProducts();
  }, []);
  const getProducts = async () => {
    
    StartLoading(setisLoading);
    try {
      await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetmySuppliers`, { app : 0 }, { withCredentials: true })
        .then((res) => {
          StopLoading(setisLoading);
          if (res.data.success === 1) {
            setProducts(res.data.data);
          }
          else {
            StopLoading(setisLoading)
            showToast(res.data.message, 'error');
          }
        })
        .catch((err) => {
          StopLoading(setisLoading)
          showToast('Something went wrong ! please try again ', 'error');
        });
    } catch (err) {
      StopLoading(setisLoading);
      showToast("Failed to get suplliers, please try again later ", 'error');
    }
  }
  return { users,isLoading, selectsupplier, handleCall, products }
}

export default MidViewSuppliers